import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";


const OddsWidgetAsyncComponent = AsyncComponent(async () => import('./odds-by-widget' /* webpackChunkName: "odds-by-widget" */ ));
export const OddsByWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper>
    <React.Suspense fallback={<div/>}>
      <OddsWidgetAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
}
